import { createSelector } from 'reselect'
import { getCanViewLuxPlusBenefits, getIsFreePreviewLuxPlusMember } from './featureToggle'

export const getActiveOrRenewingLuxPlusSubscriptionId = createSelector(
  (state: App.State) => state.auth.account.luxPlus.member.subscription.item,
  (subscription): string | undefined => {
    if (subscription?.status !== 'ACTIVE' && subscription?.status !== 'AWAITING_RENEWAL') return undefined

    return subscription.id
  },
)

export const getHasPaidLuxPlusMembershipInCurrentRegion = createSelector(
  (state: App.State) => getCanViewLuxPlusBenefits(state),
  (state: App.State) => getIsFreePreviewLuxPlusMember(state),
  (canViewLuxPlusBenefits, isFreePreviewLuxPlusMember): boolean =>
    canViewLuxPlusBenefits && !isFreePreviewLuxPlusMember,
)
